var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ai-name-big-tree-container", style: _vm.containerStyle },
    [
      _c(
        "svg",
        {
          attrs: {
            width: _vm.svgWidth,
            height: _vm.svgHeight,
            viewBox: "0 0 96 233",
            version: "1.1",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        [
          _c("title", [_vm._v("aiNameBigTree")]),
          _vm._v(" "),
          _c("defs", [
            _c(
              "filter",
              {
                attrs: {
                  x: "-3.5%",
                  y: "-2.6%",
                  width: "106.9%",
                  height: "105.2%",
                  filterUnits: "objectBoundingBox",
                  id: _vm.filterId1
                }
              },
              [
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "1 0", in: "SourceGraphic" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "filter",
              {
                attrs: {
                  x: "-1.7%",
                  y: "-1.3%",
                  width: "103.3%",
                  height: "102.6%",
                  filterUnits: "objectBoundingBox",
                  id: _vm.filterId2
                }
              },
              [
                _c("feGaussianBlur", {
                  attrs: { stdDeviation: "0.5 0", in: "SourceGraphic" }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "g",
            {
              attrs: {
                id: "首页",
                stroke: "none",
                "stroke-width": "1",
                fill: "none",
                "fill-rule": "evenodd"
              }
            },
            [
              _c(
                "g",
                {
                  attrs: {
                    id: "首页-ai选题-已生成",
                    transform: "translate(-860.000000, -5898.000000)"
                  }
                },
                [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "第二部分备份-3",
                        transform: "translate(0.000000, 4851.000000)"
                      }
                    },
                    [
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "位图备份",
                            transform: "translate(126.000000, 689.625592)"
                          }
                        },
                        [
                          _c(
                            "g",
                            {
                              attrs: {
                                id: "编组-71",
                                transform: "translate(581.000000, 316.374408)"
                              }
                            },
                            [
                              _c(
                                "g",
                                {
                                  attrs: {
                                    id: "编组",
                                    transform:
                                      "translate(156.631336, 43.000000)"
                                  }
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d:
                                        "M8.46841957,116 C41.7168362,116.672623 63.8321729,119.727684 74.8144298,125.165182 C85.5864735,129.384514 90.5984613,129.384514 89.8503933,125.165182 L85.3323237,122.736261 C63.0496907,115.387431 40.1705562,111.713016 16.69492,111.713016 C10.2672212,112.880023 7.52505436,114.309017 8.46841957,116 Z",
                                      id: "路径-64",
                                      fill: _vm.fillColor1
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "编组-73",
                                        transform:
                                          "translate(0.000000, 113.000000)",
                                        fill: _vm.fillColor2
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 70.737548,9.25597894 83.4875888,2.86065398 L86.6835708,2.22280132 L86.1273093,0 Z",
                                          id: "路径-7",
                                          transform:
                                            "translate(43.341785, 57.454517) scale(1, -1) translate(-43.341785, -57.454517) "
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 70.737548,9.25597894 83.4875888,2.86065398 L86.6835708,2.22280132 L86.1273093,0 Z",
                                          id: "路径-7",
                                          filter: _vm.filterUrl1,
                                          transform:
                                            "translate(43.341785, 57.454517) scale(1, -1) translate(-43.341785, -57.454517) "
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "g",
                                    {
                                      attrs: {
                                        id: "编组-69",
                                        fill: _vm.fillColor3
                                      }
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 74.2620694,8.25246782 87.0121101,1.85714286 L90.2080921,1.21929021 L86.1273093,0 Z",
                                          id: "路径-7",
                                          filter: _vm.filterUrl2
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("path", {
                                        attrs: {
                                          d:
                                            "M86.1273093,0 C67.045033,1.22312067 53.8372282,25.2940588 46.5038949,72.2128144 C40.0175349,97.0169691 24.5162366,110.194435 0,111.745212 L0,114.857385 C12.4436923,115.366427 23.2311611,112.112796 32.3624063,105.096491 C41.4936516,98.0801867 47.6157998,87.1189611 50.7288508,72.2128144 C53.8427393,56.0034105 57.2509448,42.8126351 60.9534673,32.6404884 C66.507251,17.3822683 74.2620694,8.25246782 87.0121101,1.85714286 L90.2080921,1.21929021 L86.1273093,0 Z",
                                          id: "路径-7"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-2ceec062", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-2ceec062","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/ai-name-big-tree/ai-name-big-tree.vue
// module id = null
// module chunks = 